import ToggleGalleryListView from 'shared/components/molecules/ToggleGalleryListView/ToggleGalleryListView';
export * from 'shared/hooks/useGalleryListView';

export default ToggleGalleryListView;
